/**
 * A user's plan from theta-portal (Central) for this product (U78). `null` = no plan. Features
 * are the tier's feature keys; nothing is gated by them yet.
 */
export interface Plan {
  product: string;
  /** Tier slug, e.g. "pro". */
  tier: string;
  tierName: string;
  /** Central's entitlement status: active | expired | cancelled | revoked | pending. */
  status: string;
  features: string[];
  /** End of the paid period / expiry (ISO), if any. */
  periodEnd?: string;
}

/** Active and not past its period end. */
export function planActive(plan: Plan | null | undefined, now: number): boolean {
  if (!plan || plan.status !== 'active') return false;
  return plan.periodEnd === undefined || Date.parse(plan.periodEnd) > now;
}

/** Whether an active plan unlocks `feature` (U78: no gate uses this yet). */
export function hasFeature(plan: Plan | null | undefined, feature: string, now: number): boolean {
  return planActive(plan, now) && plan!.features.includes(feature);
}
